import { Box, Flex, Icon, Text } from '@chakra-ui/react';
import { ChevronRightIcon } from '@heroicons/react/24/outline';
import type { ComponentType, SVGProps } from 'react';

type Props = {
  icon: ComponentType<SVGProps<SVGSVGElement>>;
  title: string;
  description: string;
  iconBg: string;
  iconColor?: string;
  onClick: () => void;
};

export default function QuickActionTile({
  icon,
  title,
  description,
  iconBg,
  iconColor = 'fg.strong',
  onClick,
}: Props) {
  return (
    <Flex
      as='button'
      type='button'
      onClick={onClick}
      align='center'
      gap={3}
      p={4}
      border='1px solid'
      borderColor='border'
      borderRadius='lg'
      bg='bg.panel'
      textAlign='left'
      width='100%'
      transition='all 0.18s ease'
      shadow='sm'
      _hover={{
        shadow: 'md',
        transform: 'translateY(-2px)',
      }}
      _active={{ transform: 'translateY(0)' }}
    >
      <Flex
        align='center'
        justify='center'
        w={10}
        h={10}
        borderRadius='md'
        bg={iconBg}
        flexShrink={0}
      >
        <Icon as={icon} w={5} h={5} color={iconColor} />
      </Flex>
      <Box flex='1' minW={0}>
        <Text fontSize='ui' fontWeight='700' color='fg.strong' lineHeight={1.2}>
          {title}
        </Text>
        <Text fontSize='sm' color='fg.muted' mt={1} lineHeight={1.35}>
          {description}
        </Text>
      </Box>
      <Icon as={ChevronRightIcon} w={4} h={4} color='fg.subtle' flexShrink={0} />
    </Flex>
  );
}
